import { matchPath } from 'react-router'
import { RACES_ROUTES } from '@core/AppRoutes'

export const isRaceRoute = (path: string): boolean =>
  RACES_ROUTES.some(route => matchPath(path, route as string))
